import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    project: string;
    type: string;
    insertedDateTime: (insertedTime: Date) => string;
    insertedDateTimeA11y: (insertedTime: Date) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for project */
            project: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_ProjectDetailPane.project?c=1y2semxo3c9fl", defaultMessage: "Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for type */
            type: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_ProjectDetailPane.type?c=k5idcnlneisq", defaultMessage: "Type" }));
                },
                enumerable: true,
                configurable: true
            },
            /**
             * Inserted date/time in readable format
             * Example (en-US): "Jan 15, 2026 at 2:30 PM"
             */
            insertedDateTime: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (insertedTime: Date): string => __intl__.intl().formatMessage({ id: "QuickSearch_ProjectDetailPane.insertedDateTime?c=mzu6tnn6zbfq", defaultMessage: "{insertedTime, date, medium} at {insertedTime, time, short}" }, { insertedTime: insertedTime }));
                },
                enumerable: true,
                configurable: true
            },
            /**
             * Inserted date/time in full a11y format
             * Example (en-US): "January 15, 2026 at 2:30 PM"
             */
            insertedDateTimeA11y: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (insertedTime: Date): string => __intl__.intl().formatMessage({ id: "QuickSearch_ProjectDetailPane.insertedDateTimeA11y?c=25tjhoej6hwqc", defaultMessage: "{insertedTime, date, long} at {insertedTime, time, short}" }, { insertedTime: insertedTime }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
